/* eslint-disable react/prop-types */
import assign from 'lodash/assign';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import pathsManifest from '../../../../pathsManifest';
import RatingAndReviewActions from '../../../../flux/actions/RatingAndReviewActions';
import queryUtil from '../../../../utils/queryUtils';

import RateProperty from './RateProperty';

class PropertyRatingAndReviewRatePage extends React.Component {
  constructor(props) {
    super(props);
  }

  handleBack = () => {
    const { dispatch, routingLocation, propertyRating } = this.props;

    const query = assign({}, queryUtil.parse(routingLocation.search), { propertyRating });
    const queryString = queryUtil.stringify(query);
    dispatch(push(pathsManifest.propertyRatingAndReviewTenantPage + queryString));
  };

  handleNext = () => {
    // attach rating as a query param in case of a refresh
    const { dispatch, routingLocation, propertyRating } = this.props;

    const query = assign({}, queryUtil.parse(routingLocation.search), { propertyRating });
    const queryString = queryUtil.stringify(query);
    dispatch(push(pathsManifest.propertyRatingAndReviewCommentPage + queryString));
  };

  handleStarRatingClick = (numOfStars) => {
    this.props.dispatch(RatingAndReviewActions.editPropertyRating(numOfStars));
  };

  render() {
    const { propertyRating, tenantType } = this.props;

    return (
      <div className="PropertyRatingAndReviewRatePage">
        <RateProperty
          propertyRating={propertyRating}
          onBack={this.handleBack}
          onNext={this.handleNext}
          defaultStarRating={propertyRating}
          onStarRatingClick={this.handleStarRatingClick}
          tenantType={tenantType}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  propertyRating: state.ratingAndReview.propertyRating,
  tenantType: state.ratingAndReview.tenantType,
  routingLocation: state.router.location,
});

export default connect(mapStateToProps)(PropertyRatingAndReviewRatePage);
